
































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Slide } from '../@types/Slide'
import Tracker from '@/components/Tracker.vue'

@Component({
  components: {
    Tracker
  }
})
export default class TrackerContainer extends Vue {
  @Prop({ required: true }) public slides: Slide[]

  /**
   * Opened.
   */
  public opened: boolean = false

  /**
   * Toggle opened.
   */
  public toggle() {
    this.opened = !this.opened
  }

  @Watch('$route.path')
  public close() {
    this.opened = false
    ;(this.$refs.tracker as Tracker).closeChildren()
  }
}
